<template lang="html">
  <Content class="content-sm" style="width: 100%; max-width: 300px; margin: 2em auto; padding: 1em; min-height: auto; flex-grow: 0; text-align: center">
    <h1>Feder Centri</h1>
    <h2>Reset Password</h2>
    <br>
    <Alert v-if="alert" :type="alert.type" show-icon>
      {{ alert.txt }}
    </Alert>
    <Form @submit.native.prevent="reset">
      <FormItem>
        <Input v-model="form.email" type="email" required placeholder="Email"/>
      </FormItem>
      <FormItem>
        <Input v-model="form.password" type="password" required placeholder="Password"/>
      </FormItem>
      <FormItem>
        <Input v-model="form.password_confirmation" type="password" required placeholder="Conferma Password"/>
      </FormItem>
      <FormItem style="text-align: center">
        <Button html-type="submit" type="primary" :loading="loading">
          <Icon type="key"></Icon>
          Reset
        </Button>
        <br>
      </FormItem>
    </Form>
  </Content>
</template>

<script>
export default {
  data () {
    return {
      alert: null,
      form: {
        token: this.$route.params.token
      },
      login_failed: false,
      loading: false,
    }
  },

  methods: {
    reset() {
      if(this.form.email == null){
        this.alert = {
          type: 'error',
          txt: 'Bisogna inserire una mail valida'
        }
      }
      else {
        if(this.form.password == this.form.password_confirmation){
          this.loading = true
          this.$http.post('.s/auth/reset', this.form).then(res => {
            var token = res.data.token
            this.$http.get('auth/me?token='+token).then(res => {
              this.$store.session = {
                token,
                user: res.data
              }
              this.$router.push('/')
            })
          }, err => {
            console.log('error', err)
            this.alert = {
              type: 'error',
              txt: 'Assicurarsi che la mail sia valida e la password abbia almeno 8 caratteri'
            }
          }).finally(res => {this.loading = false})
        }
        else {
          this.alert = {
            type: 'error',
            txt: 'Le password devono corrispondere!'
          }
        }
      }
    }
  }
}
</script>

<style lang="css">
</style>
